import { getRateString, generateTermRange, getTermBestEdgeString, getMaxAmount } from '../../helpers/humanization.js';

const getBusinessDepositTerms = item => {
    // Ставка, Срок, Сумма, Открытие онлайн
    const conditions = [];
    // ставка
    const { rateOnline } = item;
    if (rateOnline > 0) {
        conditions.push({ value: getRateString(rateOnline), description: 'Ставка онлайн', key: 'rate-online' });
    }
    else if (rateOnline) {
        conditions.push({ value: getRateString(item.rate), description: 'Ставка', key: 'rate' });
    }
    // срок
    const { timeFrom, timeTo } = item;
    const termRange = generateTermRange({ dictDateFrom: ['day'], dictDateTo: ['day'], to: timeTo, from: timeFrom });
    // сумма
    const { minSum, maxSum } = item;
    const sumRange = { from: minSum, to: maxSum };
    conditions.push({
        value: getTermBestEdgeString(termRange),
        description: 'Срок',
        wide: true,
        key: 'term',
    });
    conditions.push({
        value: getMaxAmount(sumRange, { isConvert: true }),
        description: 'Сумма',
        wide: true,
        key: 'sum',
    });
    // Открытие онлайн
    // опечатки нет в depozitOption1
    const online = item.depozitOption1?.includes('onlineOpen');
    conditions.push({ value: online ? 'Да' : 'Нет', description: 'Открытие онлайн', key: 'online-open' });
    return conditions;
};

export { getBusinessDepositTerms };
//# sourceMappingURL=businessDeposit.js.map
